const SIZES = [
	'B', 
	'KB', 
	'MB', 
	'GB', 
	'TB'
];

/**
* @ngdoc filter
* @name phoenix.filter:pxItemSize
* @kind function
* 
* @description
*  Converts a size in bytes to human readable text
*
* @param {string|number} bytes An item size in bytes.
* 
*/
export function ItemSizeFilter() {
	return function toHumanReadable(bytes:string|number) {
		if (!bytes) {
			return null;
		}

		if(typeof bytes === 'string'){
			bytes = parseInt(bytes);
		}

		if (bytes <= 0) {
			return '0 B';
		}

		let unitIndex = Math.floor(Math.log(bytes) / Math.log(1024));
		let unit = SIZES[unitIndex];

		let constant:string|number = bytes / Math.pow(1024, unitIndex);
		if (unit !== 'B') {
			constant = constant.toFixed(2);
		}

		return constant + ' ' + unit;
	};
}


// WEBPACK FOOTER //
// ./src/phoenix/filters/itemSize.ts